import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "./stores/auth";

import { useCurrentMenuStore } from "./stores/current-menu";

import Dashboard from "./pages/Dashboard.vue";
import Login from "./pages/Login.vue";
import MenuIndex from "./pages/menus/MenuIndex.vue";
import MenuView from "./pages/menus/MenuView.vue";
import Settings from "./pages/Settings.vue";
import Users from "./pages/Users.vue";
import ResetPassword from "./pages/ResetPassword.vue";
import NewPassword from "./pages/NewPassword.vue";

const router = createRouter({
    history: createWebHistory(),
    base: process.env.APP_URL,
    routes: [
        {
            path: "/reset-password/:link",
            name: "reset-password",
            component: NewPassword,
            meta: {
                auth: false,
                title: "Reset Password",
            },
        },

        {
            path: "/",
            component: Dashboard,
            meta: {
                auth: true,
                title: "Dashboard",
            },
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                title: "Login",
                transition: "none",
            },
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: ResetPassword,
            meta: {
                auth: false,
                title: "Forgot Password",
            },
        },
        {
            path: "/menus",
            name: "menus",
            component: MenuIndex,
            meta: {
                auth: true,
                title: "Menus",
            },
        },
        {
            path: "/menus/:menu",
            name: "menus-view",
            component: MenuView,
            meta: {
                auth: true,
                title: "Menus",
            },
        },
        {
            path: "/settings",
            name: "settings",
            component: Settings,
            meta: {
                auth: true,
                title: "Settings",
            },
        },
        {
            path: "/users",
            name: "users",
            component: Users,
            meta: {
                auth: true,
                title: "Users",
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} - ${process.env.MIX_APP_NAME}`;

    const currentMenu = useCurrentMenuStore();

    if (currentMenu.hasChanges) {
        if (
            !confirm(
                "You have unsaved changes! Are you sure you want to leave?"
            )
        ) {
            return false;
        } else {
            currentMenu.reset();
        }
    }

    if (to.meta.auth == true) {
        if (useAuthStore().authenticated) {
            currentMenu.reset();
            next();
        } else {
            currentMenu.reset();
            next({ name: "login" });
        }
    } else {
        currentMenu.reset();
        next();
    }
});

export default router;
